module.exports = __webpack_public_path__ + "static/img/qr_public.8674fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/qr_public.png
// module id = 1PER
// module chunks = 0